import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";
import { Award, Flame } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const StreakPanel = () => {
  const { getToken } = useAuth();
  const [s, setS] = useState(null);
  useEffect(() => { (async () => { const r = await axios.get(`${API}/me/streak`, { headers: { Authorization: `Bearer ${await getToken()}` } }); setS(r.data); })().catch(() => {}); }, [getToken]);
  if (!s) return null;
  return <div className="streak" data-testid="streak-panel">
    <div className="streak-main"><Flame size={26} className={s.current ? "flame on" : "flame"}/><div><strong data-testid="streak-current">{s.current}</strong><span>DAY STREAK</span></div>
      <div className="streak-stats"><span>BEST <b data-testid="streak-longest">{s.longest}</b></span><span>ITEMS <b>{s.ticks}</b></span><span>{s.active_today ? "✓ ACTIVE TODAY" : "TICK AN ITEM TODAY"}</span></div></div>
    <div className="badges">{s.badges.map(b => <div key={b.id} className={b.earned ? "badge earned" : "badge"} title={b.description} data-testid={`badge-${b.id}`}><Award size={15}/><span>{b.name}</span><small>{b.description}</small></div>)}</div>
  </div>;
};
